import { Component } from '@angular/core';

@Component({
	styleUrls: ['./welcome-dialog.component.scss'],
	templateUrl: 'welcome-dialog.component.html',
})
export class WelcomeDialogComponent {}
